import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import { useApi } from "../../../../hooks/useApi";
import React, { useState, useEffect } from "react";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Blank from "../../../DefaultStyles/Blank";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { ILms } from "../../../../pages/Message/LMS";
import DotStatus from "../../../DefaultStyles/DotStatus";
import SMSStatusCheckBtn from "../../Message/Lms/SMSStatusCheckBtn";
import dayjs from "dayjs";
import LineBtn from "../../../Button/LineBtn";
import LmsModal from "../../Message/LmsModal";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";
import Pagination from "../../../Table/Pagination";

export default function UserDetailLMS({ userId }: { userId?: string }) {
  const auth = useRecoilValue(authType);
  const [page, setPage] = useState(0);
  const [viewBtnClick, setViewBtnClick] = useState(false);
  const [viewData, setViewData] = useState({
    user: "",
    sender: "",
    title: "",
    id: "",
    sendTime: "",
  });
  const [lmsDetail, setLmsDetail] = useState<AxiosResponse | undefined>(
    undefined
  );

  const { response, loading, error } = useApi({
    method: "get",
    url:
      userId && auth?.kakao
        ? `kakao/lms?page=${page}&size=5&uid=${+userId}`
        : undefined,
  });

  const lmsInfoHeader = ["제목", "송신 확인", "발송 일시", "조회"];

  //   lms 상세정보 받기
  const {
    response: lmsDetailResponse,
    loading: lmsDetailLoading,
    error: lmsDetailError,
  } = useApi({
    url:
      viewBtnClick && viewData?.id !== ""
        ? `kakao/lms/${viewData?.id}`
        : undefined,
  });

  useEffect(() => {
    if (lmsDetailResponse) {
      setLmsDetail(lmsDetailResponse);
    }
  }, [lmsDetailResponse]);

  useEffect(() => {
    if (lmsDetailError) {
      toast.error(lmsDetailError?.data ?? "LMS 조회에 실패했습니다.");
    }
  }, [lmsDetailError]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "LMS 조회에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      {response?.data?.items?.length > 0 && (
        <>
          <LineBox>
            <>
              <TitleWithLine title="LMS" />
              <Blank blankHeight={24} />
              <Table tableHeadData={lmsInfoHeader}>
                <>
                  {response?.data?.items?.map((d: ILms) => (
                    <TableBody key={d?.id}>
                      <TableBodyItem>{d?.title}</TableBodyItem>
                      <TableBodyItem>
                        {d?.status ? (
                          <DotStatus
                            text={d?.status === "-100" ? "성공" : "실패"}
                            color={d?.status === "-100" ? "#00c7c7" : "#f42d16"}
                            size="sm"
                          />
                        ) : (
                          <SMSStatusCheckBtn messageId={d?.messageid} />
                        )}
                      </TableBodyItem>

                      <TableBodyItem>
                        {d?.time
                          ? dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableBodyItem>

                      <TableBodyItem>
                        <LineBtn
                          btnText="조회"
                          btnClickEvent={() => {
                            setViewBtnClick(true);
                            setViewData({
                              sender: d?.sender,
                              user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                              title: d?.title,
                              id: d?.messageid,
                              sendTime: d?.time,
                            });
                          }}
                          disabled={!auth?.kakao}
                        />
                      </TableBodyItem>
                    </TableBody>
                  ))}
                </>
              </Table>

              <Pagination
                totalPage={response?.data?.totalPage ?? 3}
                currentPage={page}
                pageClickEvent={(index) => setPage(index)}
              />
            </>
          </LineBox>
        </>
      )}

      {(lmsDetailLoading || loading) && <Loader />}

      {/* lms 조회 모달 */}
      {lmsDetail && (
        <LmsModal
          closeEvent={() => {
            setViewBtnClick(false);
            setViewData({
              sender: "",
              title: "",
              user: "",
              id: "",
              sendTime: "",
            });
            setLmsDetail(undefined);
          }}
          confirmEvent={() => setViewBtnClick(false)}
          viewData={viewData}
          lmsDetail={lmsDetail}
        />
      )}
    </>
  );
}
